export const GET_LEAVES_REQUESTS = 'GET_LEAVES_REQUESTS';
export const UPDATE_REQUEST = 'UPDATE_REQUEST';
export const GET_TYPES = 'GET_TYPES';
export const CREATE_TYPE = 'CREATE_TYPE';
export const DELETE_TYPE = 'DELETE_TYPE';
export const GET_LEAVE_TOTALS = 'GET_LEAVE_TOTALS';
